import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import { CustomAutocomplete, CustomTextField, LoaderComponent, TabTextLabel } from "@/shared/components/ui";
import { City, Province, Sector } from "@/shared/interfaces";
// import { CapacidadCorporativa } from "@/shared/interfaces/erp/planes_corporativos/planes_corporativos.interface";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import CustomCoordendasForm from "../form_coordenadas/CustomCoordendasForm";
import { useState } from "react";
import { useFetchCoberturasCiudadEnabled, useFetchCoberturasProvincia } from "@/shared/actions/erp";

interface TabCaracteristicasEnlaceCorporativoProps {
  form: UseFormReturn<IPreventaCorporativoForm2, any, IPreventaCorporativoForm2>
  // dataCapacidadCorporativo: CapacidadCorporativa[];
  // isLoadingCapacidadCorporativo: boolean;
  sectorsByZonePaging?: any;
  isLoadingSectors?: any;
  disabledAll?: boolean;
}



export default function TabCaracteristicasEnlaceCorporativo({
  form,
  sectorsByZonePaging,
  isLoadingSectors,
  // dataCapacidadCorporativo,
  // isLoadingCapacidadCorporativo,
  disabledAll = false,
}: TabCaracteristicasEnlaceCorporativoProps) {

  const [selectedProvince, setSelectedProvince] = useState('');
  const [, setSelectedCity] = useState('');

  const {
    // reset,
    control,
    formState: { errors },
  } = form;




  const { data: provinceByCountry, isLoading: isLoadingProvinceByCountry } =
    useFetchCoberturasProvincia({
      page_size: 1000,
      cobertura: undefined,
      estado: true
    });

  const { data: citiesByProvince, isLoading: isLoadingCities } =
    useFetchCoberturasCiudadEnabled({
      enabled: !!form.watch().provincia,
      params: {
        provincia: selectedProvince,
        page_size: 1000,
        estado: true,
        cobertura: undefined,
      },
    });

  return (
    <Grid container {...gridSizeMdLg12} rowSpacing={6} columnSpacing={2} >

      <Grid item container spacing={2} {...gridSizeMdLg6}>

        {/* <CustomAutocompleteArrString
          size={gridSizeMdLg12}
          label={"Medio / Última Milla"}
          name="medio_ultima_milla"
          options={MEDIO_ULTIMA_MILLA}
          defaultValue={form.getValues().medio_ultima_milla}
          isLoadingData={false}
          control={form.control}
          error={errors.medio_ultima_milla}
          helperText={errors.medio_ultima_milla?.message}
          disabled={disabledAll}
          required={false}
        /> */}
        {/* <CustomAutocompleteArrString
          size={gridSizeMdLg12}
          label={"Tipo de Puertos para Recibir el Servicio"}
          name="tipo_puerto_disponible"
          options={TIPO_PUERTOS_SERVICIO}
          defaultValue={form.getValues().tipo_puerto_disponible}
          isLoadingData={false}
          control={form.control}
          error={errors.tipo_puerto_disponible}
          helperText={errors.tipo_puerto_disponible?.message}
          disabled={disabledAll}
          required={false}
        />
         */}
      </Grid>

      {/* <Grid item container spacing={2} justifyContent={'start'} alignContent={'start'} {...gridSizeMdLg12}> */}

      {/* <CustomAutocomplete<CapacidadCorporativa>
          size={gridSizeMdLg12}
          label={"Enlace (Mbps)"}
          name="capacidad"
          options={dataCapacidadCorporativo||[]}
          defaultValue={form.getValues().capacidad}
          isLoadingData={false}
          control={form.control}
          error={errors.capacidad}
          helperText={errors.capacidad?.message}
          valueKey="capacidad" // name is the fk
          actualValueKey="codigo"
          disabled={disabledAll}
        /> */}


      {/* <SampleCheckbox
          size={gridSizeMdLg3}
          label='Energía Regulada'
          control={form.control}
          name='energia_regulada'
          defaultValue={form.getValues().energia_regulada || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), energia_regulada: e })
          }}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          label="Energía Regulada"
          name="energia_regulada"
          control={control}
          defaultValue={!!form.getValues().energia_regulada}
          size={gridSizeMdLg3}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          size={gridSizeMdLg3}
          label='Espacio Para Equipos'
          control={form.control}
          name='espacio_equipos'
          defaultValue={form.getValues().espacio_equipos || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), espacio_equipos: e })
          }}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          label="Espacio Para Equipos"
          name="espacio_equipos"
          control={control}
          defaultValue={!!form.getValues().espacio_equipos}
          size={gridSizeMdLg3}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          size={gridSizeMdLg3}
          label='Zona Soterrada'
          control={form.control}
          name='zona_soterrada'
          defaultValue={form.getValues().zona_soterrada || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), zona_soterrada: e })
          }}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          label="Zona Soterrada"
          name="zona_soterrada"
          control={control}
          defaultValue={!!form.getValues().zona_soterrada}
          size={gridSizeMdLg3}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          size={gridSizeMdLg3}
          label='Instalación por Ductos'
          control={form.control}
          name='instalacion_ductos'
          defaultValue={form.getValues().instalacion_ductos || false}
          onChangeValue={(e) => {
            form.reset({ ...form.getValues(), instalacion_ductos: e })
          }}
          disabled={disabledAll}
        /> */}
      {/* <SampleCheckbox
          label="Instalación por Ductos"
          name="instalacion_ductos"
          control={control}
          defaultValue={!!form.getValues().instalacion_ductos}
          size={gridSizeMdLg6}
          disabled={disabledAll}
        /> */}
      {/* </Grid> */}

      <Grid item container spacing={2} justifyContent={'start'} alignContent={'start'} {...gridSizeMdLg12}>

        <CustomCoordendasForm
          form={form}
          label="Coordendas Empresa"
          name="coordenada_empresa"
          defaultValue={form.watch().coordenada_empresa}
          key={'key_coordenada_empresa'}
          size={gridSizeMdLg6}
          onlyValueLocation={true}
          disabled={false}
          required={false}
        />

        <CustomTextField
          control={control}
          name="direccion_empresa"
          defaultValue={form.getValues().direccion_empresa}
          size={gridSizeMdLg6}
          label={'Dirección Empresa'}
          error={errors.direccion_empresa}
          helperText={errors.direccion_empresa?.message}
          required={false}
        />

        <CustomCoordendasForm
          form={form}
          label="Coordendas Servicio"
          name="coordenada_servicio"
          defaultValue={form.watch().coordenada_servicio}
          key={'key_coordenada_servicio'}
          size={gridSizeMdLg6}
          // autoLocation={true}
          enableLocationOnChange={true}
          disabled={false}
          required={true}
        />

        <CustomTextField
          control={control}
          name="direccion_servicio"
          defaultValue={form.getValues().direccion_servicio}
          size={gridSizeMdLg6}
          label={'Dirección Servicio'}
          error={errors.direccion_servicio}
          helperText={errors.direccion_servicio?.message}
          required={true}
        />
      </Grid>
      {
        (form.getValues().zona)
          && (form.getValues().provincia)
          && (form.getValues().ciudad)
          ?

          <Grid item container spacing={2} {...gridSizeMdLg12}>
            <TabTextLabel
              text="Zona con cobertura, por favor, complete la información restante."
              pb={"0px"} color="#47B004" />
            {
              isLoadingSectors ?
                <LoaderComponent />
                :
                <>
                  <CustomTextField
                    control={control}
                    name="zona_nombre"
                    defaultValue={form.getValues().zona_nombre || form.getValues().zona_data?.nombre}
                    size={gridSizeMdLg6}
                    label={'Zona'}
                    error={errors.zona_nombre}
                    helperText={errors.zona_nombre?.message}
                    disabled={true}
                    required={false}
                  />
                  <CustomTextField
                    control={control}
                    name="provincia_nombre"
                    defaultValue={form.getValues().provincia_nombre || form.getValues().provincia_data?.nombre}
                    size={gridSizeMdLg6}
                    label={'Provincia'}
                    error={errors.provincia_nombre}
                    helperText={errors.provincia_nombre?.message}
                    disabled={true}
                    required={false}
                  />
                  <CustomTextField
                    control={control}
                    name="ciudad_nombre"
                    defaultValue={form.getValues().ciudad_nombre || form.getValues().ciudad_data?.nombre}
                    size={gridSizeMdLg6}
                    label={'Ciudad'}
                    error={errors.ciudad_nombre}
                    helperText={errors.ciudad_nombre?.message}
                    disabled={true}
                    required={false}
                  />

                  <CustomAutocomplete<Sector>
                    size={gridSizeMdLg6}
                    label={"Sector"}
                    name="sector"
                    options={sectorsByZonePaging?.data || []}
                    defaultValue={form.watch().sector}
                    isLoadingData={false}
                    control={form.control}
                    error={errors.sector}
                    helperText={errors.sector?.message}
                    valueKey="alias" // name is the fk
                    actualValueKey="codigo"
                    disabled={disabledAll}
                    required={false}
                  />
                </>
            }
          </Grid>
          :
          <Grid item container spacing={2} {...gridSizeMdLg12}>
            <TabTextLabel
              text="No existe cobertura en las coordenadas ingresadas. Ingrese manualmente los datos."
              pb={"0px"} color="#FF5100" />
            <CustomAutocomplete<Province>
              size={gridSizeMdLg6}
              label={"Provincia"}
              name="provincia"
              options={provinceByCountry?.data || []}
              defaultValue={form.watch().provincia}
              isLoadingData={isLoadingProvinceByCountry}
              control={form.control}
              error={errors.provincia}
              helperText={errors.provincia?.message}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              disabled={disabledAll}
              onChangeValue={(e) => {
                setSelectedProvince(e)
              }}
              required={false}
            />
            <CustomAutocomplete<City>
              size={gridSizeMdLg6}
              label={"Ciudad"}
              name="ciudad"
              options={citiesByProvince?.data?.data || []}
              defaultValue={form.watch().ciudad}
              isLoadingData={isLoadingCities}
              control={form.control}
              error={errors.ciudad}
              helperText={errors.ciudad?.message}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              disabled={disabledAll}
              onChangeValue={(e) => {
                setSelectedCity(e)
              }}
              required={false}
            />
            <CustomTextField
              control={control}
              name="sector_tentativo"
              defaultValue={form.getValues().sector_tentativo}
              size={gridSizeMdLg6}
              label={'Sector'}
              error={errors.sector_tentativo}
              helperText={errors.sector_tentativo?.message}
              required={false}
            />


          </Grid>
      }
    </Grid>
  )

}